import type { ReactElement } from "react";
import { Link } from "react-router";

import { usePageMeta } from "../../app/use-page-meta.js";

/** 読むだけの画面（ログインの一時停止・見つからない）。 */

export function LockoutPage(): ReactElement {
    usePageMeta("ログインの一時停止");

    return (
        <div className="page max-w-lg">
            <div className="panel-message">
                <h1 className="page-title">ログインを一時的に停止しています</h1>
                {/* 5 回・30 分は Implem.Portal.Backend の Identity の設定（Lockout）と同じにする */}
                <p className="page-lead">
                    パスワードを続けて 5 回間違えたため、このアカウントのログインを 30 分間停止しています。
                    30 分ほどおいてから、もう一度お試しください。
                    パスワードをお忘れの場合は、再設定できます。
                </p>
                {/* 操作の入口は文中のリンクにしない（docs/01 §6） */}
                <div className="flex flex-col justify-center gap-3 sm:flex-row">
                    <Link to="/Account/Login" className="btn-secondary">ログイン画面へ戻る</Link>
                    <Link to="/Account/ForgotPassword" className="btn-secondary">パスワードをお忘れの方</Link>
                </div>
            </div>
        </div>
    );
}

/**
 * 会員の画面の中で、受け持っていない URL を開いたとき。
 *
 * <b>SWA は外枠（app.html）を返しているので、状態コードは 200 のまま</b>になる。
 * 見た目は公開側の 404 と同じにする。
 */
export function NotFoundPage(): ReactElement {
    usePageMeta("ページが見つかりません");

    return (
        <div className="page max-w-lg">
            <div className="panel-message">
                <h1 className="page-title">ページが見つかりません</h1>
                <p className="page-lead">お探しのページは移動または削除された可能性があります。</p>
                <a href="/" className="btn-secondary">トップへ戻る</a>
            </div>
        </div>
    );
}
